import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreOrganizationsAllReducers, coreOrganizationsAllWatchers } from './all';
import { coreOrganizationsByIdReducers, coreOrganizationsByIdWatchers } from './_id';
import { coreOrganizationsUnlinkReducers, coreOrganizationsUnlinkWatchers } from './unlink';
import { coreSalesforceOrganizationsReducers, coreSalesforceOrganizationsWatchers } from './salesforce';
import { coreOrganizationsLinkReducers, coreOrganizationsLinkWatchers } from './link';

export const coreOrganizationsReducers = combineReducers({
	all: coreOrganizationsAllReducers,
	byId: coreOrganizationsByIdReducers,
	link:  coreOrganizationsLinkReducers,
	salesforce: coreSalesforceOrganizationsReducers,
	unlink: coreOrganizationsUnlinkReducers
});

export const coreOrganizationsWatchers = combineAllWatchers([
	coreOrganizationsAllWatchers,
	coreOrganizationsByIdWatchers,
	coreOrganizationsLinkWatchers,
	coreOrganizationsUnlinkWatchers,
	coreSalesforceOrganizationsWatchers
]);
